import { format } from 'date-fns';
export const getFormattedDateValue = (value, dateFormat) => {
    if (!value) {
        return '';
    }
    return format(new Date(value + 'T00:00:00.000'), dateFormat);
};
